import { ReactNode } from "react";
import Navbar from "./Navbar";

interface MainLayoutProps {
  children: ReactNode;
}

/**
 * MainLayout - Componente de layout principal que envuelve todas las rutas protegidas
 * Proporciona la navegación consistente y el fondo gradiente
 * 
 * Uso:
 * <MainLayout>
 *   <Dashboard />
 * </MainLayout>
 */
export default function MainLayout({ children }: MainLayoutProps) {
  return (
    <Navbar>
      {children}
    </Navbar>
  );
}
